var $ = require("jquery");

require('webpack-jquery-ui/autocomplete');

import ViewRegistry from "./utils/register";
import HomeView from "./views/home";
import NavigationView from "./views/navigation";
import SliderView from "./views/slider";
import SearchView from "./views/search";
import NewsletterSubView from "./views/newsletter-sub";
import FeaturedNewsView from "./views/featuredNews";
import lightbox from "./lightbox";
import {setUpCSRF} from "./utils/csrf";

$(function () {
    setUpCSRF();
    window.viewRegistry = new ViewRegistry();
    window.viewRegistry.addView(HomeView, "home");
    window.viewRegistry.addView(NavigationView, "nav");
    window.viewRegistry.addView(SliderView, "slider");
    window.viewRegistry.addView(SearchView, "search");
    window.viewRegistry.addView(NewsletterSubView, "newsletter-sub");
    window.viewRegistry.addView(FeaturedNewsView, "featured-news");
    window.viewRegistry.initViews();

    lightbox.option({
        'albumLabel': 'Bild %1 von %2'
    });
});



// WEBPACK FOOTER //
// ./frontend/js/frontend.js